export function UpcomingBillsPanel({ data }) {
  const { bills = [] } = data

  const now = new Date()
  const currentDay = now.getDate()

  const upcoming = bills
    .map((bill) => {
      let daysUntilDue = bill.due_day - currentDay
      if (daysUntilDue < 0) daysUntilDue += 31
      const dueDate = new Date(now.getFullYear(), now.getMonth(), bill.due_day)
      if (dueDate < now) {
        dueDate.setMonth(dueDate.getMonth() + 1)
        daysUntilDue = Math.ceil((dueDate - now) / 86400000)
      }
      const overdue = bill.last_paid_at
        ? new Date(bill.last_paid_at).getMonth() < now.getMonth() && daysUntilDue > 20
        : false
      return { ...bill, daysUntilDue, dueDate, overdue }
    })
    .filter((b) => b.daysUntilDue <= 14)
    .sort((a, b) => a.daysUntilDue - b.daysUntilDue)

  return (
    <div className="flex flex-col h-full px-4 sm:px-8 py-4 sm:py-6 panel-animate-in min-h-0">
      <p className="text-gray-500 text-xs sm:text-sm font-semibold uppercase tracking-widest mb-3">Upcoming Bills</p>

      {upcoming.length === 0 ? (
        <div className="flex-1 flex flex-col items-center justify-center">
          <div className="text-5xl sm:text-6xl mb-3">✅</div>
          <p className="text-gray-400 text-lg sm:text-xl">No bills due in the next 14 days</p>
        </div>
      ) : (
        <div className="flex-1 space-y-2 overflow-y-auto min-h-0 scrollbar-hide">
          {upcoming.map((bill) => (
            <div
              key={bill.id}
              className={`flex items-center gap-3 sm:gap-4 rounded-xl sm:rounded-2xl px-4 sm:px-5 py-3 sm:py-4 ${
                bill.overdue ? 'bg-red-500/20 border border-red-500/30' : 'bg-white/8'
              }`}
            >
              <div className="flex-1 min-w-0">
                <p className="text-white text-base sm:text-xl font-semibold truncate">{bill.name}</p>
                <p className={`text-xs sm:text-sm mt-0.5 ${bill.overdue ? 'text-red-400' : bill.daysUntilDue <= 3 ? 'text-amber-400' : 'text-gray-400'}`}>
                  {bill.overdue ? 'Possibly overdue' : bill.daysUntilDue === 0 ? 'Due today' : `Due in ${bill.daysUntilDue} days`}
                </p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-white text-lg sm:text-2xl font-bold">${Number(bill.amount).toFixed(2)}</p>
                <p className="text-gray-500 text-xs sm:text-sm capitalize">{bill.frequency}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
